<div>
    <h2><mat-icon>insert_comment</mat-icon> {{ asset.comment_count }} Comments</h2>

    <frog-annotation-list [asset]="asset"></frog-annotation-list>
</div>
